import { sanitize } from 'isomorphic-dompurify';
import z from 'zod';

import { TypeaheadSearchResult } from 'src/types/model';

export const getRecentSearchQueries = (localStorageKey: string): TypeaheadSearchResult[] => {
  // Retrieve recent search queries from localStorage
  const storedQueries = localStorage.getItem(localStorageKey);
  if (!storedQueries) return [];
  try {
    const parsed = JSON.parse(storedQueries);
    const zodSchema = z.array(
      z.object({
        title: z.string(),
        value: z.string(),
      })
    );
    const result = zodSchema.safeParse(parsed); // Validate the structure of the parsed data
    if (!result.success) {
      console.error('Invalid recent search queries:', result.error);
      return [];
    }
    return result.data.map(({ title, value }) => ({
      title: sanitize(title),
      value: sanitize(value),
    }));
  } catch (error) {
    console.error('Failed to parse recent search queries:', error);
    return [];
  }
};

export const addQueryToRecentSearches = (query: TypeaheadSearchResult, localStorageKey: string) => {
  const recentSearchQueries = getRecentSearchQueries(localStorageKey);
  // Avoid duplicates
  const updatedQueries = [
    query,
    ...recentSearchQueries.filter((q) => q.title !== query.title && q.value !== query.value),
  ];
  // Limit to last 5 searches
  const limitedQueries = updatedQueries.slice(0, 5);
  localStorage.setItem(localStorageKey, JSON.stringify(limitedQueries));
};

export const deleteQueryFromRecentSearches = (
  query: TypeaheadSearchResult,
  localStorageKey: string
) => {
  const recentSearchQueries = getRecentSearchQueries(localStorageKey);
  const updatedQueries = recentSearchQueries.filter(
    (q) => q.title !== query.title && q.value !== query.value
  );
  localStorage.setItem(localStorageKey, JSON.stringify(updatedQueries));
};
